
<v-flex>
    <div class="float-left mr-10" style="min-width: 350px;">
        <card-unit :items="[
            { text: t('webhook_log_label_id') || 'ID', value: log.id },
            { text: t('webhook_log_label_type') || 'Type', value: log.type },
            { text: t('webhook_log_label_rc_event_id') || 'RC Event ID', value: log.rcEventId },
            { text: t('webhook_log_label_user_id') || 'User ID', value: log.userId || '-' },
            { text: t('webhook_log_label_created_at') || 'Created At', value: log.createdAt ? log.createdAt.format('DD/MM/YYYY HH:mm:ss') : '-' },
            { text: t('webhook_log_label_processed_at') || 'Processed At', value: log.processedAt ? log.processedAt.format('DD/MM/YYYY HH:mm:ss') : '-' },
        ]">
            <template #title>{{ t('webhook_log_card_title_details') || 'Details' }}</template>
        </card-unit>
    </div>

    <div class="float-left" style="width: 100%; max-width: 600px;">
        <v-card class="elevation-1">
            <v-card-title class="pb-2 text-subtitle-1 font-weight-bold" style="color: #3D4A6B;">
                {{ t('webhook_log_label_payload') || 'Payload (JSON)' }}
            </v-card-title>
            <v-card-text>
                <v-sheet
                    color="grey lighten-4"
                    class="pa-4 rounded"
                    style="max-height: 500px; overflow-y: auto;"
                >
                    <pre style="font-size: 12px; white-space: pre-wrap; word-wrap: break-word; color: #2c3e50;">{{
                            formattedPayload
                        }}</pre>
                </v-sheet>
            </v-card-text>
        </v-card>
    </div>
</v-flex>
